import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { AgGridFilterEnumComponent } from './ag-grid-filter-enum.component';

@NgModule({
  declarations: [AgGridFilterEnumComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  exports: [AgGridFilterEnumComponent],
})
export class AgGridFilterEnumModule { }
